import React, { useState } from "react";
import { IconButton, TextField } from "@material-ui/core";

import { Icon } from "./icons/Icon";

type Props = {
  onSearch: (searchInput: string) => void;
  onReset: () => void;
  disabled?: (search: string) => boolean;
};

const SearchBar: React.FC<Props> = ({ onSearch, onReset, disabled }) => {
  const [searchInput, setSearchInput] = useState("");

  return (
    <>
      <TextField
        onChange={event => {
          setSearchInput(event.target.value);
        }}
        onKeyPress={event => {
          if (event.key === "Enter") {
            onSearch(searchInput);
          }
        }}
        placeholder="Search"
        value={searchInput}
      />
      <IconButton
        disabled={disabled && disabled(searchInput)}
        onClick={() => {
          onSearch(searchInput);
        }}
      >
        <Icon name="search" />
      </IconButton>
      <IconButton
        onClick={() => {
          setSearchInput("");
          onReset();
        }}
      >
        <Icon name="close" />
      </IconButton>
    </>
  );
};

export default SearchBar;
